import management from '@/router/home/hr/management';

const hr = [
  {
    path: '/hr/management',
    component: () => import('@/page/hr/Management.vue'),
    redirect: '/hr/management/working',
    children: [...management],
    meta: {
      name: '인력',
      isMenu: false,
      isActive: false,
      isBread: true,
    },
  },
  {
    path: '/hr/dept',
    component: () => import('@/page/hr/Dept.vue'),
    meta: {
      name: '소속/부서',
      isActive: false,
      isBread: true,
    },
  },
  {
    path: '/hr/organization',
    component: () => import('@/page/hr/Organization.vue'),
    meta: {
      name: '조직도',
      isActive: false,
      isBread: true,
    },
  },
];

export default hr;
